<template>
  <div class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col-12">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('contactUs.breadcrumb_1')}}</router-link></li>
            <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active mx-3 almarai-bold" aria-current="page">{{$t('contactUs.breadcrumb_2')}}</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>

  <div class="container pt-3">
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <div class="row pt-3 justify-content-center">
      <div class="col-12 col-md-8">
        <div class="card border-0" v-if="step == 1">
          <div class="card-body">
            <form action="">
              <div class="row">
                <div class="col-12">
                  <label for="" class="p-content">{{$t('contactUs.name')}}<span class="stars">*</span></label>
                  <input type="text" maxlength="50" v-model="name" class="form-control input-style">
                </div>
                <div class="error-feedback red-color fonttext-14" v-if="validate.name.$error">
                  {{validateMessage }}
                </div>
              </div>
              <div class="row pt-2">
                <div class="col-12">
                  <label for="" class="p-content">{{$t('contactUs.communication')}}<span class="stars">*</span></label>
                  <input type="text" v-model="mobile" class="form-control input-style"
                    maxlength="10" @input="mobile = mobile.replace(/[^0-9]/g, '')"
                  >
                </div>
                <div class="error-feedback red-color fonttext-14" v-if="validate.mobile.$error">
                  {{validateMessage }}
                </div>
              </div>

              <div class="row pt-2">
                <div class="col-12">
                  <label for="" class="p-content">{{$t('contactUs.description')}}<span class="stars">*</span></label>
                  <textarea class="form-control br-radius" v-model="subject"  rows="4"></textarea>
                </div>
                <div class="error-feedback red-color fonttext-14" v-if="validate.subject.$error">
                  {{validateMessage }}
                </div>
              </div>

              <div class="row pt-2">
                <div class="col">
                  <label for="" class="p-content">⁠⁠{{$t('contactUs.uploadingImages')}}</label>
                  <input type="file" class="form-control" @change="uploadFile($event.target.files)" multiple accept="image/*,application/pdf">
                </div>
              </div>

              <div class="row pt-4 justify-content-center">
                <div class="col-12 col-md-7 mouse-hand" @click.prevent='contactUs'>
                  <div v-if="isLoading" class="text-center">
                    <loader />
                  </div>
                  <div v-else class="btn-green">⁠{{$t('contactUs.send')}}</div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row pt-3 justify-content-center" v-if="step == 2">
      <div class="col-11 col-md-6">
        <div class="card br-radius-24">
          <div class="card-body text-center">
            <div>
              <img src="/assets/images/icons/new-success.png" class="max-50" alt="">
            </div>
            <p class="p-content mb-0 pt-3">{{$t('contactUs.receivedDetails')}}</p>
            <div class="row py-3 justify-content-center">
              <div class="col-11 col-md-6 text-center">
                <router-link to="/">
                  <div class="btn-black">{{$t('contactUs.btn_submit')}}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
export default {
  name: "contactUs",
  data(){
    return{
      hasError: false,
      message: "",
      errorNumber: 0,
      name: "",
      mobile: "",
      subject: "",
      files: [],
      validateMessage: this.$t('validateMessage'),
      isLoading: false,
      // successMessage: "استلمنا بلاغك وجاري التحقق منه",
      hassuccess: false,
      userLang: 'ar',
      step: 1,
    }
  },
  setup () {
    return { validate: useVuelidate() }
  },
  validations (){
    return {
      name: {required},
      mobile: {required},
      subject: {required},
    }
  },
  methods: {
    async contactUs(){
      this.hasError = false;
      if(this.mobile.trim().length != 10 || !this.mobile.startsWith('05')){
        this.message = this.$t('incorrectMobile');
        this.hasError = true;
        window.scrollTo({top:0, behavior:'smooth'});
        return false;
      }
      const valid = await this.validate.$validate();
      if(!valid){
        window.scrollTo({top:0, behavior: 'smooth'});
        return false;
      }
      this.isLoading = true;
      const formData = new FormData();
      formData.append('name', this.name);
      formData.append('mobile', this.mobile);
      formData.append('subject', this.subject);
      if(this.files && this.files.length){
        for(let rf=0; rf<this.files.length; rf++){
          formData.append('attachments', this.files[rf]);
        }
      }
      this.$http.post('/api/contactUs/create', formData).then(res => {
        // console.log(res);
        this.step = 2;
        this.name = "";
        this.mobile = "";
        this.subject = "";
        this.files = [];
        window.scroll(0,0)
        this.isLoading = false;
      }).catch(err => {
        console.log(err);
        this.isLoading = false;
      });
    },

    uploadFile(e){
      this.files = [...e];
    },
  },
  created(){
    this.userLang = localStorage.getItem('lang') ??  'ar';
    window.scroll(0,0)
  }
}
</script>